<template>
  <div class="left-box">
    <div class="user-info info-box">
      <!-- 会员信息 -->
      <div class="title">会员信息</div>
      <div class="content">
        <div class="info-item">账号：{{ userInfo.username }}</div>
        <div class="info-item">信用余额：{{ userInfo.credits }}</div>
        <div class="info-item">
          可用：<span class="active-text">{{
            userInfo.balance.toFixed(2)
          }}</span>
          <i
            @click="handleRefreshGameInfo"
            style="cursor: pointer; margin-left: 10px"
            class="refresh-icon fa fa-refresh active-text"
          ></i>
          <!-- <img
            style="margin-left: 10px; cursor: pointer"
            :src="require('@/assets/images/leftbox/reload.png')"
            width="11"
          /> -->
        </div>
      </div>
    </div>
    <div class="order-info info-box">
      <!-- 订单信息 -->
      <div class="title">订单打印</div>
      <div class="content" ref="table1">
        <div class="info-item">彩种：{{ gameInfo && gameInfo.gameName }}</div>
        <div class="info-item">会员：{{ userInfo && userInfo.username }}</div>
        <div class="info-item">编号：{{ gameInfo && gameInfo.nextQihao }}</div>
        <div class="info-item">时间：{{ time }}</div>
      </div>
      <div style="max-height: 200px; overflow-y: auto">
        <table class="order-table" ref="table2">
          <thead>
            <th>号码</th>
            <th>赔率</th>
            <th>金额</th>
          </thead>
          <tbody>
            <tr v-for="item in currentBetList" :key="item.id">
              <td>{{ item.betNumber }}</td>
              <td>{{ item.peilv }}</td>
              <td>{{ item.money }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content">
        <!-- <div
          class="info-item"
          style="justify-content: space-between"
          ref="table3"
        >
          <div style="width: 50%">笔数：{{ totalNum }}</div>
          <div style="width: 50%">总额：{{ totalMoney || "0.00" }}</div>
        </div> -->
        <div class="info-item">本期笔数：{{ totalNum }}</div>
        <div class="info-item">本期总额：{{ totalMoney || "0.00" }}</div>
        <div class="info-item">
          {{ gameInfo && gameInfo.nextQihao }}期，3天内有效！
        </div>
        <div class="btn-group">
          <div class="btn primary" @click="print()">打印</div>
          <div class="btn info" @click="clear()">重置</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      id: -1,
      isRotate: false,
      canGetList: true,
      totalNum: 0,
      totalMoney: "0.00",
      userInfo: {
        username: "",
        credits: "",
        balance: 0,
      },
      time: "-",
      bh: "-",
      currentBetList: [],
    };
  },
  mounted() {
    this.initData();
  },
  props: ["gameInfo"],
  methods: {
    async initData() {
      this.getUserInfo();
      this.$BUS.$on("getGameInfoFinished", () => {
        this.getCurrentBetList();
        this.scrollConfig();
      });
      this.$BUS.$on("bet", () => {
        this.getCurrentBetList();
        this.getUserInfo();
      });
      this.$BUS.$on("updateUserInfo", () => {
        this.getUserInfo();
      });
      this.title = sessionStorage.getItem("title");
    },
    handleRefreshGameInfo(e) {
      e.target.classList.add("active");
      setTimeout(() => {
        e.target.classList.remove("active");
        this.$message.success("刷新成功");
      }, 500);
      this.getUserInfo();
    },
    async getUserInfo() {
      let access_token = this.$store.state.userInfo.access_token;
      let uid = this.$store.state.userInfo.uid;
      let data = {
        access_token,
        uid,
      };
      let result = await this.$http.postAxiosMethod("/user/userinfo", data, {
        hideLoading: true,
      });
      if (result.data && result.code == 0) {
        this.userInfo = result.data;
        sessionStorage.setItem("isplayer", result.data.isplayer);
        sessionStorage.setItem("skin", result.data.skin);
        this.$BUS.$emit("setSkin", result.data.skin);
        this.$store.state.user = result.data;
        this.$store.state.userInfo = Object.assign(
          this.$store.state.userInfo,
          result.data
        );
      }
    },
    async refresh() {
      this.isRotate = true;
      await this.getUserInfo();
      setTimeout(() => {
        this.isRotate = false;
        this.$message({
          type: "success",
          message: "刷新成功",
        });
      }, 500);
    },
    async getCurrentBetList(id) {
      let access_token = this.$store.state.userInfo.access_token;
      let uid = this.$store.state.userInfo.uid;
      let game_code = this.$store.state.gameInfo[0].code;
      let data = {
        access_token,
        uid,
        game_code,
        id,
      };
      let result = await this.$http.postAxiosMethod(
        "/user/currentissuebetlist",
        data,
        { hideLoading: true }
      );
      if (result.data && result.code == 0) {
        if (id && id != -1) {
          this.currentBetList = [...this.currentBetList, ...result.data];
          if (result.data.length !== 0) {
            this.id = result.data[result.data.length - 1].id;
          }
        } else {
          this.currentBetList = result.data;
          this.id =
            result.data.length == 0
              ? -1
              : result.data[result.data.length - 1].id;
        }
        this.time = this.getLocalTime(result.betTime);
        this.bh = result.orderId || "-";
        this.totalNum = result.totalNum;
        this.totalMoney = result.totalMoney;
      }
    },
    async clear() {
      if (this.currentBetList.length === 0) {
        document.activeElement.blur();
        this.$alert("暂无数据清除", "提示");
        return;
      }
      let access_token = this.$store.state.userInfo.access_token;
      let uid = this.$store.state.userInfo.uid;
      let game_code = this.$store.state.gameInfo[0].code;
      let data = {
        access_token,
        game_code,
        uid,
      };
      let result = await this.$http.postAxiosMethod("/user/chearBetList", data);
      if (result.code == 0) {
        this.getCurrentBetList();
      }
    },
    print() {
      if (this.currentBetList.length === 0) {
        document.activeElement.blur();
        this.$alert("暂无打印数据", "提示");
        return;
      }
      let table1 = this.$refs.table1.innerHTML;
      let table2 = this.$refs.table2.innerHTML;
      let table3 = this.$refs.table3.innerHTML;
      let printHtml = `<div class="game_box_title t_1" style="background-color: white;">
                                    <div class="history_wrap zchy">
                                        <table>
                                            ${table1}
                                        </table>
                                        <table>
                                            <tbody id="last_list">
                                                ${table2}
                                                ${table3}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>`;
      let bdhtml = window.document.body.innerHTML;
      window.document.body.innerHTML = printHtml; //把需要打印的指定内容赋给body.innerHTML
      window.print(); //调用浏览器的打印功能打印指定区域
      window.document.body.innerHTML = bdhtml; // 最后还原页面
      window.location.reload();
    },
    scrollConfig() {
      // this.$nextTick(function () {
      //   let scrollbar = this.$refs.scroll.$refs.wrap;
      //   let _this = this;
      //   scrollbar.onscroll = async () => {
      //     if (
      //       scrollbar.clientHeight + scrollbar.scrollTop >=
      //       scrollbar.scrollHeight - 20
      //     ) {
      //       if (_this.canGetList) {
      //         _this.canGetList = false;
      //         await _this.getCurrentBetList(_this.id);
      //         _this.canGetList = true;
      //       }
      //     }
      //   };
      // });
    },
    getLocalTime(nS) {
      if (nS) {
        let time = new Date(parseInt(nS) * 1000)
          .toLocaleString()
          .replace(/\//g, "-");
        if (time.includes("下午")) {
          time = time.replace(
            /上午|下午\d/g,
            12 + parseInt(time[time.indexOf("下午") + 2])
          );
        } else {
          time = time.replace(/上午|下午/g, " ");
        }
        return time;
      } else {
        return "-";
      }
    },
  },
};
</script>
<style lang="scss">
.sidebar {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
}
</style>

<style lang="scss" scoped>
.left-box {
  margin-right: 20px;
  width: 200px;
  height: calc(100% - 100px);
  font-size: 12px;
  .refresh-icon {
    &.active {
      animation: circle 1s ease-in-out;
    }
  }
  @keyframes circle {
    0% {
      transform: rotate(0);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .info-box {
    border-radius: 10px;
    overflow: hidden;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    > .title {
      height: 30px;
      line-height: 30px;
      color: #fff;
      text-align: center;
      background: var(--new-bg-primary);
    }
    > .content {
      padding: 12px 20px;
      background: #fff;
      > .info-item {
        display: flex;
        align-items: center;
        &:not(:last-child) {
          margin-bottom: 5px;
        }
      }
      .btn-group {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }
  }

  .order-table {
    border-collapse: collapse;
    background: var(--new-bg-white);
    width: 100%;
    td,
    th {
      padding: 0px 10px;
      height: 28px;
      text-align: center;
      border: 1px solid var(--new-border);
    }
  }
}
</style>
